<template>
  <div class="form-container">
    <div class="form">
      <div class="form__title">
        <h1>Add A Partner</h1>
        <p>Request partner access to the Client Portal</p>
      </div>
      <q-form
        @submit.prevent="onSubmit"
        style="  width: 100%;  max-width: 640px;"
        class="q-gutter-y-md"
      >
        <!-- Email -->
        <q-input
          ref="input"
          outlined
          type="email"
          v-model="form.email"
          label="Email *"
          color="secondary"
          lazy-rules
          :rules="[(val) => !!val || 'Email is missing', isValidEmail]"
          ><template v-slot:prepend>
            <q-icon
              name="mail_outline
"
            />
          </template>
        </q-input>
        <!-- Name -->
        <div class="row q-col-gutter-md q-gutter-y-md">
          <div class="col">
            <q-input
              outlined
              type="text"
              v-model="form.firstname"
              label="First Name *"
              color="secondary"
              lazy-rules
              :rules="[
                (val) => !!val || '* Required',
                (val) => val.length > 1 || 'Please enter your full name',
              ]"
              ><template v-slot:prepend>
                <q-icon name="mood" />
              </template>
            </q-input>
          </div>

          <div class="col">
            <q-input
              outlined
              type="text"
              v-model="form.surname"
              label="Surname *"
              color="secondary"
              lazy-rules
              :rules="[
                (val) => !!val || '* Required',
                (val) => val.length > 1 || 'Please enter your full name',
              ]"
              ><template v-slot:prepend>
                <q-icon name="mood" />
              </template>
            </q-input>
          </div>
        </div>

        <!-- Operator -->
        <q-select
          class="select"
          :display-value="
            ` ${
              persistentOperatorFilter.OperatorID === 0
                ? 'All Operators'
                : persistentOperatorFilter.Operator
            }`
          "
          virtual-scroll-slice-size="30"
          virtual-scroll-item-size="30"
          popup-content-class="select__options"
          options-dense
          v-model="selectedOperator"
          :options="operatorList"
          option-value="OperatorID"
          option-label="Operator"
          outlined
          :clearable="persistentOperatorFilter.OperatorID === 0 ? false : true"
          clear-icon="close"
          color="secondary"
          @input="
            setOperator(
              selectedOperator ? selectedOperator.OperatorID : 0,
              selectedOperator ? selectedOperator.Operator : ''
            )
          "
          @clear="setOperator(0, '')"
          :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
        >
          <template v-slot:option="scope">
            <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
              class="select__options--item"
            >
              <q-item-section>
                <q-item-label v-html="scope.opt.Operator" />
              </q-item-section>
            </q-item>
          </template>
          <template v-slot:prepend>
            <q-icon name="corporate_fare" />
          </template>
        </q-select>
        <!-- Network -->
        <q-select
          class="select q-gutter-y-md"
          :display-value="
            ` ${
              persistentNetworkFilter.id === 0
                ? 'All Networks'
                : persistentNetworkFilter.name
            }`
          "
          virtual-scroll-slice-size="30"
          virtual-scroll-item-size="30"
          popup-content-class="select__options"
          options-dense
          v-model="selectedNetwork"
          :options="networkList"
          option-value="NetworkID"
          option-label="Network"
          outlined
          :clearable="persistentNetworkFilter.id === 0 ? false : true"
          clear-icon="close"
          color="secondary"
          @input="
            setNetwork(
              selectedNetwork ? selectedNetwork.NetworkID : 0,
              selectedNetwork ? selectedNetwork.Network : ''
            )
          "
          @clear="setNetwork(0, '')"
          :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
        >
          <template v-slot:option="scope">
            <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
              class="select__options--item"
            >
              <q-item-section>
                <q-item-label v-html="scope.opt.Network" />
              </q-item-section>
            </q-item>
          </template>
          <template v-slot:prepend>
            <q-icon name="podcasts" />
          </template>
        </q-select>
        <!-- Sites -->
        <q-select
          class="select q-gutter-y-md "
          :display-value="
            ` ${
              persistentSiteFilter.id === 0
                ? 'All Sites'
                : persistentSiteFilter.name
            }`
          "
          virtual-scroll-slice-size="30"
          virtual-scroll-item-size="30"
          popup-content-class="select__options"
          options-dense
          v-model="selectedSite"
          :options="siteList"
          option-value="SiteID"
          option-label="Site"
          outlined
          :clearable="persistentSiteFilter.id === 0 ? false : true"
          clear-icon="close"
          color="secondary"
          @input="
            setSite(
              selectedSite ? selectedSite.SiteID : 0,
              selectedSite ? selectedSite.Site : ''
            )
          "
          @clear="setSite(0, '')"
          :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
        >
          <template v-slot:option="scope">
            <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
              class="select__options--item"
            >
              <q-item-section>
                <q-item-label v-html="scope.opt.Site" />
              </q-item-section>
            </q-item>
          </template>
          <template v-slot:prepend>
            <q-icon name="web" />
          </template>
        </q-select>

        <div class="q-pt-md">
          <q-btn
            label="Submit"
            type="submit"
            color="secondary"
            class="full-width"
            unelevated
            no-caps
          />
          <p v-if="error">{{ error }}</p>
          <p v-if="success">{{ success }}</p>
        </div>
      </q-form>
    </div>
    <SuccessMessage :message="this.success" v-show="success" />
  </div>
</template>
<script>
import SuccessMessage from "@/components/other/SuccessMessage.vue";
export default {
  props: {
    formType: String,
  },
  data() {
    return {
      form: {
        email: "",
        firstname: "",
        surname: "",
        operator: "",
        network: "",
        site: "",
      },
      success: false,
      error: null,

      operatorList: [],
      selectedOperator: 0,
      networkList: [],
      selectedNetwork: 0,
      siteList: [],
      selectedSite: 0,
      filterOption: {
        operator: 0,
        site: 0,
        network: 0,
      },
      persistentOperatorFilter: {
        OperatorID: 0,
        Operator: "",
      },
      persistentNetworkFilter: {
        id: 0,
        name: "",
      },
      persistentSiteFilter: {
        id: 0,
        name: "",
      },
    };
  },
  components: {
    SuccessMessage,
  },

  mounted() {
    // Fetch all filter lists on load. Use persistent operator and networks if set.
    this.fetchOperator();
    this.fetchNetwork(
      this.persistentOperatorFilter.OperatorID
        ? this.persistentOperatorFilter.OperatorID
        : this.$store.state.userDetails.operatorId
    );
    this.fetchSites(
      this.persistentOperatorFilter.OperatorID
        ? this.persistentOperatorFilter.OperatorID
        : this.$store.state.userDetails.operatorId,
      this.persistentNetworkFilter.id
    );
  },

  methods: {
    // Fetch all data
    fetchOperator() {
      // No dataset or filter options for operator list, store will handle operator ID.
      const payload = {
        filterOptions: {},
        report: "operator-list",
        dataset: "",
      };

      this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          this.operatorList = response.data;
        })
        .catch((error) => {
          this.errors.push(error);
        });
    },
    fetchNetwork(operatorId) {
      // No dataset for network list, store will handle operator ID if not supplied.
      const payload = {
        filterOptions: { operatorId },
        report: "network-list",
        dataset: "",
      };

      this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          if (response.data.length == 0) {
            this.networkList = [{ Network: "None", NetworkID: 0 }];
          } else {
            this.networkList = response.data;
          }
        })
        .catch((error) => {
          this.errors.push(error);
        });
    },
    fetchSites(operatorId, networkId) {
      // No dataset for network list, store will handle operator ID if not supplied.
      const payload = {
        filterOptions: {
          operatorId,
          networkId,
        },
        report: "user-site-list",
        dataset: "",
      };

      this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          this.siteList = response.data;
        })
        .catch((error) => {
          this.errors.push(error);
        });
    },

    // Operator change action: Set the operator and reset network and site.
    setOperator(operatorId, operatorName) {
      // Update the filters on this page.
      this.persistentOperatorFilter = {
        OperatorID: operatorId,
        Operator: operatorName,
      };
      this.form.operator = operatorName;
      this.persistentNetworkFilter = { id: 0, name: "" };
      this.persistentSiteFilter = { id: 0, name: "" };

      // Clear network and site in model if an operator selection changes.
      this.selectedNetwork = 0;
      this.selectedSite = 0;
      this.form.network = "";
      this.form.site = "";

      // Refresh the network and site lists based on the selected operator
      this.fetchNetwork(operatorId ? operatorId : 0);
      this.fetchSites(operatorId ? operatorId : 0, null);
    },

    // Network action
    setNetwork(networkId, networkName) {
      // Update the filters on this page.
      this.form.network = networkName;
      this.persistentNetworkFilter = { id: networkId, name: networkName };
      this.persistentSiteFilter = { id: 0, name: "" };

      // Clear site in model if network selection changes.
      this.selectedSite = 0;
      this.form.site = "";

      // Refresh site list based on the network selection.
      this.fetchSites(
        this.persistentOperatorFilter.OperatorID,
        networkId ? networkId : null
      );
    },

    // Site action
    setSite(siteId, siteName) {
      // Set the site filter for this page.
      this.form.site = siteName;
      this.persistentSiteFilter = { id: siteId, name: siteName };
    },

    // Input validations
    isValidEmail(val) {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      return emailPattern.test(val) || "Invalid email";
    },

    onSubmit: function(event) {
      // type is the endpoint form we want to hit, added as a prop
      const payload = {
        form: {
          type: this.$props.formType,
          content: {
            Email: this.form.email,
            Firstname: this.form.firstname,
            Surname: this.form.surname,
            Operator: this.form.operator ? this.form.operator : "All Operators",
            Network: this.form.network ? this.form.network : "All Networks",
            Site: this.form.site ? this.form.site : "All Sites",
            RequestedBy: this.$store.state.userDetails.email,
          },
        },
      };
      // After payload constructed we hit the submitEmailData action in the store
      this.$store
        .dispatch("submitEmailData", payload)
        .then(() => {
          this.success = "Request sent";
          // We then have to reset the form, a timer of 4 seconds allows animation to play while form resets
          this.form.email = "";
          this.form.firstname = "";
          this.form.surname = "";
          this.form.operator = "";
          this.form.network = "";
          this.form.site = "";
          this.setOperator(0, "");
          this.setNetwork(0, "");
          this.setSite(0, "");
          event.target.reset();
          setTimeout(() => {
            this.success = "";
            this.error = "";
          }, 4000);
        })
        .catch((error) => {
          this.error = "Request could not be sent";
          this.response = "Error: " + error.response;
        });
    },
  },
};
</script>

<style lang="scss">
.form-container {
  display: flex;
  width: 100%;
  height: 100%;
}
</style>
